import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import relativeTime from 'dayjs/plugin/relativeTime'

class DateService {
  constructor() {
    dayjs.extend(relativeTime)
    dayjs.locale('ja')
  }

  getFormatted(value) {
    if (value == undefined) {
      return ''
    }
    let unixtime = typeof value == 'number' ? value : value.getTime()
    return unixtime
      ? Intl.DateTimeFormat('default', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric'
          // second: 'numeric'
        }).format(new Date(unixtime))
      : ''
  }

  getFormattedDate(value) {
    if (value == undefined) {
      return ''
    }
    let unixtime = typeof value == 'number' ? value : value.getTime()
    return unixtime
      ? Intl.DateTimeFormat('default', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }).format(new Date(unixtime))
      : ''
  }

  getFormattedShort(value) {
    if (value == undefined) {
      return ''
    }
    if (dayjs().diff(value, 'd') < 8) {
      return dayjs().to(dayjs(value))
    }
    let format = { month: 'short', day: 'numeric' }

    if (dayjs().year() != dayjs(value).year()) {
      format = { ...format, year: 'numeric' }
    }
    let unixtime = typeof value == 'number' ? value : value.getTime()
    return unixtime
      ? Intl.DateTimeFormat('default', format).format(new Date(unixtime))
      : ''
  }

  // return: 2020030018
  getYYYYMMDDHH(date) {
    const d = date ? date : new Date()
    return (
      d.getFullYear() +
      ('0' + (d.getMonth() + 1)).slice(-2) +
      ('0' + d.getDay()).slice(-2) +
      ('0' + d.getHours()).slice(-2)
    )
  }
}
const dateService = new DateService()
export default dateService
